export default __webpack_public_path__ + "static/media/bulb.34629e26.png";